import actionTypes from "./actionTypes";

export const openUrl = url => {
  return {
    type: actionTypes.OPEN_URL,
    url: url
  };
};

export const closeUrl = () => {
  return {
    type: actionTypes.CLOSE_URL
  };
};
